// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld-base';
import 'myWorld/uiComponents/dialog';

myw.ConfirmationDialog = myw.Dialog.extend({
    options: {
        buttons: {
            OK: {
                text: '{:ok_btn}',
                class: 'primary-btn',
                click() {
                    const options = this.options;
                    let p;
                    if (options.confirmCallback) {
                        //execute the callback for confirmation
                        p = Promise.try(options.confirmCallback).return(true);
                    }
                    this._resolve(p || true); //update the promise
                    this.destroy();
                }
            },
            Cancel: {
                text: '{:cancel_btn}',
                class: 'right',
                click() {
                    this._resolve(false);
                    this.destroy();
                }
            }
        }
    },

    /**
     * @class A dialog for the user to confirm or cancel an action.
     *        Provides a promise that will be resolved when the action has been performed or when the user chooses to cancel.
     * @param  {dialogOptions} options  Options for a dialog with the addition of:
     * @param  {string} options.msg  Message to include in dialog (alternative to contents)
     * @param  {function} options.confirmCallback Function to execute when the user confirms
     * @param  {string} options.okBtnText  Text for the confirmation button
     * @param  {string} options.cancelBtnText  Text for the cancelation button
     * @example
     *  myw.confirmationDialog({title: 'A title', msg: 'Are you sure?',
            confirmCallback: 
        });
     * @extends {Dialog}
     * @constructs
     */
    initialize(options) {
        options.contents = options.msg.replace('\n', '<br/>');
        options = _.extend({}, this.options, options);
        options.buttons = { ...options.buttons };
        options.buttons.OK = { ...options.buttons.OK };
        options.buttons.Cancel = { ...options.buttons.Cancel };
        if (options.okBtnText) options.buttons.OK.text = options.okBtnText;
        if (options.cancelBtnText) options.buttons.Cancel.text = options.cancelBtnText;

        /** Promise for the decision.
         * If the user cancels, resolves to false.
         * If the user confirms, will resolve to true after the confirmCallBack has been executed
         * @type {promise<boolean>} */
        this.confirmPromise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });

        myw.Dialog.prototype.initialize.call(this, options);
    }
});

/**
 * @typedef confirmDialogOptions
 * @property {string}     title               Title of the dialog
 * @property {string}     msg                 Body content of the dialog
 * @property {string}     [okBtnText]         Label for the OK button. Defaults to ok_btn message
 * @property {string}     [cancelBtnText]         Label for the Cancel button. Defaults to cancel_btn message
 * @property {method}     confirmCallback     Method to execute when the user confirms by pressing the OK button
 */

myw.confirmationDialog = options => new myw.ConfirmationDialog(options);

export default myw.ConfirmationDialog;
